export default "__VITE_ASSET__YNdFrfzB__"